<template>
    <el-dialog class="dbman-dialog" :title="form.id ? '编辑 SQL 块' : '保存 SQL 块'"
        :model-value="modelValue" width="min(520px, 92vw)" append-to-body
        @update:model-value="$emit('update:modelValue', $event)">
        <el-form label-width="90px">
            <el-form-item label="名称">
                <el-input v-model="form.name" placeholder="请输入名称" maxlength="100" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" :rows="3" v-model="form.description" maxlength="200"
                    placeholder="可选，便于以后查阅" />
            </el-form-item>
            <el-form-item label="共享">
                <div class="dbman-switch-row">
                    <el-switch v-model="form.isShare" />
                    <span class="dbman-tips">开启后，该连接团队成员均可查看并执行</span>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dbman-dialog__foot">
                <el-button @click="$emit('update:modelValue', false)">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="submit">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../../utils/request.js';

export default {
    name: 'DbSaveBlockDialog',
    props: {
        modelValue: { type: Boolean, default: false },
        connId: { type: [String, Number], default: '' },
        block: { type: Object, default: null }
    },
    emits: ['update:modelValue', 'saved', 'changed'],
    data() {
        return {
            saving: false,
            form: { id: '', name: '', description: '', isShare: false }
        };
    },
    watch: {
        modelValue(open) {
            if (open) this.applyBlock();
        }
    },
    methods: {
        applyBlock() {
            const b = this.block || {};
            this.form = {
                id: b.id || '',
                name: b.name || '',
                description: b.description || '',
                isShare: !!b.isShare
            };
        },
        submit() {
            if (!this.form.name) {
                ElMessage({ message: '请填写名称', type: 'warning', duration: 2000 });
                return;
            }
            const block = this.block;
            if (!block || !block.sqlText || !block.sqlText.trim()) {
                ElMessage({ message: 'SQL 不能为空', type: 'warning', duration: 2000 });
                return;
            }
            this.saving = true;
            request({
                url: '/dbManSqlBlock/save',
                method: 'post',
                data: {
                    token: this.$store.state.user.token,
                    id: block.id || '',
                    connId: this.connId,
                    name: this.form.name,
                    description: this.form.description,
                    sqlText: block.sqlText,
                    databaseName: block.database || block.databaseName || '',
                    isShare: this.form.isShare,
                    orderIndex: 0
                }
            }).then(res => {
                if (res.code == 0) {
                    const saved = res.meta.dbSqlBlock;
                    ElMessage({ message: '保存成功', type: 'success', duration: 2000 });
                    this.$emit('update:modelValue', false);
                    this.$emit('saved', { block, saved });
                    this.$emit('changed');
                } else {
                    ElMessage({ message: res.msg || '保存失败', type: 'error', duration: 3000 });
                }
            }).finally(() => {
                this.saving = false;
            });
        }
    }
};
</script>

<style>
@import './dialog.css';
</style>
